














































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { ApiResponse } from '@/components/types';
import { ADD_PHONE_NUMBER } from '@/modules/organization/store';
import { AddPhoneNumber, Organization } from '@/modules/organization/types';

const OrganizationStore = namespace('organization');

@Component({})
export default class AddPhoneNumberDialog extends Vue {
  @Prop({ type: Object, required: true }) organization!: Organization;
  @OrganizationStore.Action(ADD_PHONE_NUMBER) addNumber!: (params: AddPhoneNumber) => Promise<ApiResponse>;

  dialog: boolean = false;
  loading: boolean = false;
  error: any = null;

  value: AddPhoneNumber = {
    organization_id: this.organization.id,
    phone_number: this.organization.phoneNumber || ''
  };

  @Watch('dialog')
  watchDialogClosed(dialog: boolean) {
    if (!dialog) return;

    this.value = {
      organization_id: this.organization.id,
      phone_number: this.organization.phoneNumber || ''
    };
  }

  cancel(observer?: any) {
    this.dialog = false;

    setTimeout(() => {
      this.error = null;
      observer && observer.reset();
    }, 200);
  }

  async save() {
    this.error = null;

    return await this.addNumber(this.value);
  }
}
